import React, {useState} from 'react';
import T from 'prop-types';
import {toast} from 'react-toastify';
import {ButtonOutline} from 'components/buttons';
import {createBankAccountUpdateLinkApi} from 'helpers/services/api/bankAccount';
import {DashboardHolder, DashboardTitle} from 'routes/App/dashboard/styles';
import {
  BillingBankAccountNumber,
  BillingBankDescription,
  BillingBankHeaderRow,
  BillingBankStatusBadge
} from 'routes/App/settings/styles';

const BillingBank = ({locationId, connected, lastFour, companyFound}) => {
  const [linkLoading, setLinkLoading] = useState(false);

  const openUpdateBankAccountPage = async () => {
    if (linkLoading || !locationId) {
      return;
    }
    setLinkLoading(true);
    const newTab = window.open('', '_blank');
    if (newTab) {
      newTab.opener = null;
    }
    try {
      const {data} = await createBankAccountUpdateLinkApi(locationId);
      const url = data?.data?.url;
      if (!url) {
        throw new Error('No bank account update link returned');
      }
      if (newTab) {
        newTab.location.href = url;
      } else {
        window.open(url, '_blank');
      }
    } catch (error) {
      console.error('Failed to create bank account update link', error);
      if (newTab) {
        newTab.close();
      }
      toast.error(
        'Failed to open the bank account update page. Please try again.'
      );
    } finally {
      setLinkLoading(false);
    }
  };

  return (
    <DashboardHolder>
      <DashboardTitle className='WithLine mBottom titleMd'>
        Billing Bank
      </DashboardTitle>
      <BillingBankHeaderRow>
        <BillingBankStatusBadge connected={connected}>
          {connected ? 'Connected' : 'Not connected'}
        </BillingBankStatusBadge>
        {connected && lastFour && (
          <BillingBankAccountNumber>•••• {lastFour}</BillingBankAccountNumber>
        )}
        {companyFound && (
          <ButtonOutline
            className='ButtonSmall'
            type='button'
            disabled={linkLoading}
            onClick={openUpdateBankAccountPage}
          >
            <span>
              {connected ? 'Update Bank Account' : 'Connect Bank Account'}
            </span>
          </ButtonOutline>
        )}
      </BillingBankHeaderRow>
      <BillingBankDescription>
        We use this bank account to charge self-delivery fees (e.g. driver
        payouts, delivery charges).
      </BillingBankDescription>
    </DashboardHolder>
  );
};

BillingBank.propTypes = {
  locationId: T.string,
  connected: T.bool,
  lastFour: T.string,
  companyFound: T.bool
};

BillingBank.defaultProps = {
  locationId: null,
  connected: false,
  lastFour: null,
  companyFound: false
};

export default BillingBank;
